/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AvailabilityStatus {
  AVAILABLE = 'available',
  BLOCKED = 'blocked',
  OCCUPIED = 'occupied'
}

